import { createContext } from "react";
import { IAlert } from "../interfaces";

export interface IKatreSettingsContext {
    showAlert: (alert: IAlert) => void,
    clearAlert: () => void,
    refreshData: () => void
}

export const KatreSettingsContext = createContext<IKatreSettingsContext>({} as IKatreSettingsContext);